export type ProviderSyncRunStatus =
  | 'QUEUED'
  | 'RUNNING'
  | 'RATE_LIMITED'
  | 'SUCCEEDED'
  | 'SUCCEEDED_WITH_ISSUES'
  | 'FAILED'

export interface ProviderSyncProgressSnapshot {
  status: ProviderSyncRunStatus
  totalItems?: number | null
  fetched: number
  pageCount: number
  retryAfterAt?: string | null
  errorCode?: string | null
}

export function providerSyncRunActive(run: ProviderSyncProgressSnapshot | null | undefined) {
  return run?.status === 'QUEUED' || run?.status === 'RUNNING' || run?.status === 'RATE_LIMITED'
}
